import { TFunction } from 'i18next'

export type QuickEntity = 'mission' | 'pipeline' | 'project' | 'audit' | 'incident' | 'risk' | 'plan'

/** Raw backend messages (English) → friendly copy. */
const KNOWN: Record<string, string> = {
  'Total project budget exceeds mission budget': 'quickCreate.errors.budgetExceedsMission',
  'Mission Not Found': 'quickCreate.errors.missionNotFound',
  'Pipeline must belong to the same mission as the project.': 'quickCreate.errors.pipelineOtherMission',
  'Treatment plan not found': 'quickCreate.errors.planNotFound',
  'User identity not found': 'quickCreate.errors.session',
  'Unauthenticated user': 'quickCreate.errors.session',
  'Network Error': 'quickCreate.errors.network',
}

function messageOf(error: unknown): string {
  if (typeof error === 'string') return error
  const e = error as { message?: string; response?: { data?: { message?: string } } }
  return e?.response?.data?.message || e?.message || ''
}

export function friendlyCreateError(error: unknown, entity: QuickEntity, t: TFunction): string {
  const message = messageOf(error)
  // The risk endpoint answers "Pipeline not found" when the plan is missing.
  if (message === 'Pipeline not found') {
    return t(entity === 'risk' ? 'quickCreate.errors.planNotFound' : 'quickCreate.errors.pipelineNotFound')
  }
  if (KNOWN[message]) return t(KNOWN[message])
  if (message && i18nHas(t, `errors.${message}`)) return t(`errors.${message}`)
  return t('quickCreate.errors.createFailed', { entity: t(`quickCreate.entity.${entity}`) })
}

function i18nHas(t: TFunction, key: string) {
  const value = t(key, { defaultValue: '' })
  return Boolean(value) && value !== key
}
